<template>
  <div>
    <iModal
      title="编辑首页活动"
      v-model="showModal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="150"
            @submit.native.prevent
          >
            <FormItem label="活动名称：" prop="name">
              <Input v-model="formInline.name" placeholder="请输入活动名称" />
            </FormItem>
            <FormItem label="活动名称链接：">
              <Input v-model="formInline.nameUrl" placeholder="请输入活动名称链接" />
            </FormItem>
            <FormItem label="活动英文名称：">
              <Input v-model="formInline.nameEn" placeholder="请输入活动英文名称" />
            </FormItem>
            <FormItem label="活动英文名称链接：">
              <Input v-model="formInline.nameEnUrl" placeholder="请输入活动英文名称链接" />
            </FormItem>
            <FormItem label="描述：">
              <Input type="textarea" v-model="formInline.remark" placeholder="请输入描述" />
            </FormItem>
            <FormItem label="英文描述：">
              <Input type="textarea" v-model="formInline.remarkEn" placeholder="请输入英文描述" />
            </FormItem>
            <FormItem label="链接文字：">
              <Input v-model="formInline.linkText" placeholder="请输入链接文字" />
            </FormItem>
            <FormItem label="链接文字地址：">
              <Input v-model="formInline.linkUrl" placeholder="请输入链接文字地址" />
            </FormItem>
            <FormItem label="英文链接文字：">
              <Input v-model="formInline.linkTextEn" placeholder="请输入英文链接文字" />
            </FormItem>
            <FormItem label="英文链接文字地址：">
              <Input v-model="formInline.linkUrlEn" placeholder="请输入英文链接文字地址" />
            </FormItem>
            <FormItem label="中文图片：" prop="imgUrl">
              <div class="my-upload">
                <div
                  class="my-upload-list"
                  v-for="(item, index) in uploadList"
                  :key="'upload' + index"
                  style="display:flex;align-items:center;width:100%;margin-right:0;justify-content:space-between;"
                >
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height: 100px;" />
                    <div class="my-upload-list-cover" style="width:100px;border-radius:5px;">
                      <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                      <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                    </div>
                    <Input style="width:230px;" type="text" v-model="item.linkUrl" placeholder="请输入图片链接" />
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                      <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  multiple
                  type="drag"
                  :action="uploadUrl"
                  style="display: inline-block;"
                  v-show="uploadList && uploadList.length < 3"
                >
                  <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                    <div style="font-size:25px">
                      +
                      <p style="font-size:14px">上传图片</p>
                    </div>
                  </div>
                </Upload>
                <iModal title="图片查看" cancel-text v-model="visible">
                  <div style="text-align: center;">
                    <img :src="imgName" v-if="visible" style="max-width: 100%" />
                  </div>
                </iModal>
              </div>
              <p class="upload-p" style="display:block;font-size:12px;">(图片要求：2M以下的jpg或png，建议尺寸为1920*400px)</p>
            </FormItem>
            <FormItem label="英文图片：" prop="imgUrl2">
              <div class="my-upload">
                <div
                  class="my-upload-list"
                  v-for="(item, index) in uploadList2"
                  :key="'upload' + index"
                  style="display:flex;align-items:center;width:100%;margin-right:0;justify-content:space-between;"
                >
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height: 100px;" />
                    <div class="my-upload-list-cover" style="width:100px;border-radius:5px;">
                      <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                      <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove2(item)"></Icon>
                    </div>
                    <Input style="width:230px;" type="text" v-model="item.linkUrl" placeholder="请输入图片链接" />
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                      <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload
                  ref="upload2"
                  :show-upload-list="false"
                  :default-file-list="defaultList2"
                  :on-success="handleSuccess2"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload2"
                  multiple
                  type="drag"
                  :action="uploadUrl"
                  style="display: inline-block;"
                  v-show="uploadList2 && uploadList2.length < 3"
                >
                  <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                    <div style="font-size:25px">
                      +
                      <p style="font-size:14px">上传图片</p>
                    </div>
                  </div>
                </Upload>
              </div>
              <p class="upload-p" style="display:block;font-size:12px;">(图片要求：2M以下的jpg或png，建议尺寸为1920*400px)</p>
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber :max="9999" :min="0" v-model="formInline.showIndex"></InputNumber>
              <p style="font-size:12px;">（数字越小在您的广告显示中显示越靠前）</p>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ad-home-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    const that = this;
    const validateImgUrl = (rule, value, callback) => {
      if (that.uploadList && that.uploadList.length) {
        callback();
      } else {
        callback(new Error("请上传图片"));
      }
    };
    const validateImgUrl2 = (rule, value, callback) => {
      if (that.uploadList2 && that.uploadList2.length) {
        callback();
      } else {
        callback(new Error("请上传图片"));
      }
    };
    return {
      loading: false,
      showModal: false,
      formInline: {
        name: "",
        nameUrl: "",
        nameEn: "",
        nameEnUrl: "",
        remark: "",
        remarkEn: "",
        linkText: "",
        linkUrl: "",
        linkTextEn: "",
        linkUrlEn: "",
        showIndex: 0,
      },
      ruleInline: {
        name: [{ required: true,  message: '活动名称不能为空', trigger: 'blur' }],
        imgUrl: [{ required: true, validator: validateImgUrl, trigger: 'change' }],
        imgUrl2: [{ required: true, validator: validateImgUrl2, trigger: 'change' }],
      },
      uploadList: [],
      defaultList: [],
      uploadList2: [],
      defaultList2: [],
      imgName: "",
      visible: false,
    };
  },
  watch: {
    show(val, oldVal) {
      this.init();
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions({
      putMarathon: "hostCommonModule/putMarathon",
    }),
    init() {
      if (this.editInfo) {
        if (this.editInfo.imgSet && this.editInfo.imgSet.length > 0) {
          this.editInfo.imgSet.map(c => {
            this.uploadList.push({
              status: "finished",
              percentage: 100,
              url: c.ImgUrl,
              linkUrl: c.LinkUrl
            })
          })
        }
        if (this.editInfo.imgSetEn && this.editInfo.imgSetEn.length > 0) {
          this.editInfo.imgSetEn.map(c => {
            this.uploadList2.push({
              status: "finished",
              percentage: 100,
              url: c.ImgUrl,
              linkUrl: c.LinkUrl
            })
          })
        }
        this.formInline.name = this.editInfo.name;
        this.formInline.nameEn = this.editInfo.nameEn;
        this.formInline.nameUrl = this.editInfo.nameUrl;
        this.formInline.nameEnUrl = this.editInfo.nameEnUrl;
        this.formInline.remark = this.editInfo.remark;
        this.formInline.remarkEn = this.editInfo.remarkEn;
        this.formInline.linkText = this.editInfo.linkText;
        this.formInline.linkUrl = this.editInfo.linkUrl;
        this.formInline.linkTextEn = this.editInfo.linkTextEn;
        this.formInline.linkUrlEn = this.editInfo.linkUrlEn;
        this.formInline.showIndex = this.editInfo.showIndex;
      }
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    // 上传成功
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList.push({
          url: res.list[0],
          linkUrl: "",
          status: "finished"
        });
      }
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload() {
      const limitNum = 3;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    // 移除上传图片
    handleRemove2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    // 上传成功
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2.push({
          url: res.list[0],
          linkUrl: "",
          status: "finished"
        });
      }
    },
    // 上传数量
    handleBeforeUpload2() {
      const limitNum = 3;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;

      let imgSet = [];
      this.uploadList.map(c => {
        imgSet.push({
          ImgUrl: c.url,
          LinkUrl: c.linkUrl,
        })
      })
      let imgSetEn = [];
      this.uploadList2.map(c => {
        imgSetEn.push({
          ImgUrl: c.url,
          LinkUrl: c.linkUrl,
        })
      })

      let req = {
        id: this.editInfo.id,
        name: form.name,
        nameEn: form.nameEn,
        nameUrl: form.nameUrl,
        nameEnUrl: form.nameEnUrl,
        remark: form.remark,
        remarkEn: form.remarkEn,
        linkText: form.linkText,
        linkUrl: form.linkUrl,
        linkTextEn: form.linkTextEn,
        linkUrlEn: form.linkUrlEn,
        imgSet: JSON.stringify(imgSet),
        imgSetEn: JSON.stringify(imgSetEn),
        showIndex: form.showIndex
      };
      this.loading = true;
      let bool = await this.putMarathon(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("修改失败，请重新尝试");
      } else {
        this.loading = false;
        this.$Message.success("修改成功！");
        this.cancel();
        this.$emit("finish");
        this.$emit("close");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.formInline = {
        name: "",
        nameUrl: "",
        nameEn: "",
        nameEnUrl: "",
        remark: "",
        remarkEn: "",
        linkText: "",
        linkUrl: "",
        linkTextEn: "",
        linkUrlEn: "",
        showIndex: 0,
      },
      this.uploadList = [];
      this.$refs.upload.fileList = [];
      this.uploadList2 = [];
      this.$refs.upload2.fileList = [];
      this.$refs["formInline"].resetFields();
      this.$emit("close");
      this.$emit("finish");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

